import { z } from 'zod';
/**
 * Story 6.6: Response envelope returned by `POST /api/v1/upload/reference`.
 *
 * The upload endpoint accepts a single reference image (PNG, JPEG, or WebP),
 * stores the bytes in R2 under `references/{userId}/{referenceId}.{ext}`, and
 * returns this schema inside the standard `ApiSuccessEnvelope` `data` field.
 *
 * `reference_id` is the UUID the MCP then passes into
 * `GenerateRequestSchema.reference_ids` so the backend prompt compiler flips to
 * reference-aware compilation (`hasReferences = true`) at
 * `apps/api/src/services/prompt-compiler.ts:440`.
 */
export const ReferenceUploadResponseSchema = z.strictObject({
    reference_id: z.string().uuid(),
    url: z.string().url(),
    filename: z.string().min(1).max(128),
    size_bytes: z.number().int().positive(),
    mime_type: z.enum(['image/png', 'image/jpeg', 'image/webp']),
    sha256: z.string().regex(/^[a-f0-9]{64}$/),
});
//# sourceMappingURL=upload.js.map